import { generatePath } from 'react-router';

import type { HomeWorkRequestItem } from '~/redux/api/methods/home/postHomeWork';

import { RoutePathType } from '~/routing/enums';

import type { WorkBucket, WorkItem } from '../types';

import { parseIsoDate } from '../effectiveDeadline';
import { workItemId } from '../workItemIds';

function requestHref(ticketId: string) {
  return generatePath(RoutePathType.WorkflowCLMEvolutionRequestsDetail, {
    ticketId,
  });
}

/**
 * Maps a Pilot request item to a `WorkItem` in `lane`, with no `primaryAction`.
 */
export function mapRequestItem(
  item: HomeWorkRequestItem,
  lane: WorkBucket,
): WorkItem | null {
  const deadline = parseIsoDate(item.action_date);
  if (!deadline) return null;

  const href = requestHref(item.ticket_id);

  return {
    id: workItemId('request', item.ticket_id),
    kind: 'request',
    title: item.name,
    typeLabel: item.contract_type ?? '',
    statusLabel: item.current_stage_name,
    statusTone: 'active',
    ...(item.counterparties.length > 0
      ? { counterparties: item.counterparties }
      : {}),
    deadline,
    deadlineKind: 'task_due',
    bucket: lane,
    secondaryActions: [],
    href,
  };
}
